import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgBackground4 = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 512 512",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M330.577 12.9056L254.441 1.66569C212.845 -4.40551 170.511 6.26012 136.791 31.3654L75.0945 77.3096C41.3747 102.415 18.9768 139.909 12.9056 181.423L1.66569 257.641C-4.40551 299.237 6.26012 341.571 31.3654 375.291L77.3096 436.988C102.415 470.707 139.909 493.105 181.423 499.176L257.641 510.334C299.237 516.405 341.571 505.74 375.291 480.635L436.988 434.69C470.707 409.585 493.105 372.091 499.177 330.577L510.334 254.441C516.406 212.845 505.74 170.511 480.635 136.791L434.69 75.0945C409.585 41.3747 372.173 18.9768 330.577 12.9056Z",
		fill: "currentColor"
	})
});
const ForwardRef = forwardRef(SvgBackground4);
export default ForwardRef;
